export default __webpack_public_path__ + "static/media/grip-vertical.3b764bf9.svg";